import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0056ced5")

_pushScopeId("data-v-0056ced5")
const _hoisted_1 = { class: "loading-spinner" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "spinner-main" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-spinner fa-spin fa-6x" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2
  ]))
})